import type { AppData } from '../data/types';

const estadoStyle: Record<string, string> = {
  resuelto: 'badge-green',
  parcial: 'badge-amber',
  abierto: 'badge-red',
};
const estadoLabel: Record<string, string> = {
  resuelto: '✓ Resuelto',
  parcial: '🟡 Parcial',
  abierto: '✗ Abierto',
};

export function renderHuecos(container: HTMLElement, data: AppData): void {
  const huecos = data.huecos;
  const byEstado = huecos.reduce(
    (acc, h) => {
      acc[h.estado] = (acc[h.estado] || 0) + 1;
      return acc;
    },
    {} as Record<string, number>,
  );

  const blocks = Array.from(new Set(huecos.map((h) => h.bloque || 'Sin bloque')));

  container.innerHTML = `
    <div class="p-6 space-y-4">
      <div class="grid grid-cols-4 gap-3">
        <div class="stat-card">
          <div class="stat-label">Total documentados</div>
          <div class="stat-value">${huecos.length}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">Resueltos</div>
          <div class="stat-value text-emerald-600">${byEstado.resuelto || 0}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">Parciales</div>
          <div class="stat-value text-amber-600">${byEstado.parcial || 0}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">Abiertos</div>
          <div class="stat-value text-rose-600">${byEstado.abierto || 0}</div>
        </div>
      </div>

      <div class="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <div class="px-5 py-3 border-b border-slate-200 flex items-center gap-3">
          <input
            id="huecos-filter"
            type="search"
            placeholder="Buscar id, título, contenido…"
            class="flex-1 max-w-md px-3 py-1.5 text-sm border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-pulse-400"
          />
          <select id="huecos-estado" class="text-sm px-3 py-1.5 border border-slate-300 rounded-md bg-white">
            <option value="">Todos los estados</option>
            <option value="resuelto">Solo resueltos</option>
            <option value="parcial">Solo parciales</option>
            <option value="abierto">Solo abiertos</option>
          </select>
          <select id="huecos-bloque" class="text-sm px-3 py-1.5 border border-slate-300 rounded-md bg-white">
            <option value="">Todos los bloques</option>
            ${blocks.map((b) => `<option value="${b}">${b}</option>`).join('')}
          </select>
        </div>
        <div id="huecos-list" class="divide-y divide-slate-100"></div>
      </div>
    </div>
  `;

  const listEl = container.querySelector('#huecos-list') as HTMLElement;
  const filterEl = container.querySelector('#huecos-filter') as HTMLInputElement;
  const estadoEl = container.querySelector('#huecos-estado') as HTMLSelectElement;
  const bloqueEl = container.querySelector('#huecos-bloque') as HTMLSelectElement;

  function render() {
    const q = filterEl.value.toLowerCase();
    const estado = estadoEl.value;
    const bloque = bloqueEl.value;
    const filtered = huecos.filter((h) => {
      if (estado && h.estado !== estado) return false;
      if (bloque && (h.bloque || 'Sin bloque') !== bloque) return false;
      if (q) {
        const hay = `${h.id} ${h.titulo} ${h.bloque} ${h.decision}`.toLowerCase();
        if (!hay.includes(q)) return false;
      }
      return true;
    });

    if (filtered.length === 0) {
      listEl.innerHTML = '<div class="p-10 text-center text-sm text-slate-400">Sin resultados</div>';
      return;
    }

    listEl.innerHTML = filtered
      .map(
        (h) => `
        <details class="group">
          <summary class="flex items-start gap-3 px-5 py-3 cursor-pointer hover:bg-slate-50 select-none">
            <span class="badge ${estadoStyle[h.estado]} mt-0.5">${estadoLabel[h.estado]}</span>
            <span class="text-xs font-mono text-slate-500 mt-1 shrink-0">${h.id}</span>
            <div class="flex-1 min-w-0">
              <div class="text-sm font-medium text-slate-900 truncate">${h.titulo}</div>
              <div class="text-[11px] text-slate-500 mt-0.5">${h.bloque || ''}</div>
            </div>
            <span class="text-slate-300 group-open:rotate-90 transition-transform shrink-0">▸</span>
          </summary>
          <div class="px-5 pb-4 pt-1 pl-24 text-xs text-slate-600 whitespace-pre-wrap leading-relaxed">${escapeHtml(h.decision || '(sin detalle)')}</div>
        </details>
      `,
      )
      .join('');
  }

  filterEl.addEventListener('input', render);
  estadoEl.addEventListener('change', render);
  bloqueEl.addEventListener('change', render);
  render();
}

function escapeHtml(s: string): string {
  return s.replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' })[c]!);
}
